module.exports = __webpack_public_path__ + "static/media/boomreader-qr-code.1e2d62f2.svg";